var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "mb-3": "", row: "", wrap: "" } },
    _vm._l(_vm.dtKindsOfDemand, function(demand, index) {
      return _c(
        "v-btn",
        {
          key: demand.key,
          attrs: {
            fab: "",
            color: _vm.vModel === demand.key ? "secondary" : "primary",
            flat: _vm.vModel !== demand.key,
            small: "",
            disabled: _vm.disabled
          },
          on: {
            click: function($event) {
              _vm.handleClick(demand.key)
            }
          }
        },
        [_c("v-icon", [_vm._v(_vm._s(demand.icon))])],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3227679a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3227679a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-origin-demand/template.html
// module id = null
// module chunks = 